module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-01.ba060961.png";